import {useEffect, useState} from "react";

/**
 * False until one frame AFTER {@code open} turns true, then true until it falls again.
 *
 * The seam behind shell-first dialogs (ui#836): a sheet whose body is expensive to first-mount
 * paints its frame in the opening commit and mounts the body on the very next frame, so tap→visible
 * stops scaling with the body's cost — measured on the Personalise sheet, whose catalogue of live
 * template previews put tap→dialog at ~2s under a 20x-throttled CPU while the dialog shell alone is
 * tens of milliseconds. rAF rather than a timeout so the body lands on the next paint, not after an
 * arbitrary delay; SSR-safe because effects never run during prerender.
 */
export function useMountAfterOpen(open: boolean): boolean {
	const [ready, setReady] = useState(false);
	useEffect(() => {
		if (!open) {
			setReady(false);
			return;
		}
		const frame = requestAnimationFrame(() => setReady(true));
		return () => cancelAnimationFrame(frame);
	}, [open]);
	return ready;
}
